import AppPage from '../../mixins/app-page'


import AppImgBg from '../app-img-bg'
import AppImg from '../app-img'
import AppParallax from '../app-parallax'
import AppTitle from '../app-title'
import AppTextMask from '../app-text-mask'


export default
{
    name: 'page-season',

    mixins:
    [
        AppPage
    ],

    components:
    {
        AppImgBg,
        AppImg,
        AppParallax,
        AppTitle,
        AppTextMask
    },

    mounted()
    {
        this.eventHub.$emit('bg-change', '/static/bg/bg-informations.jpg')
    },

    methods:
    {
        _onClickOnScroll()
        {
            this.$root.scrollTo(this.$root.height - 50)
        },

        _onContentResized()
        {
            this.$emit('load', this)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-season/script.js